import { reactive, ref } from 'vue'
import axios from '../plugins/axios'

export const popup = ref(null)
export const loading = reactive({
  popup: false
})

export const getPopup = async () => {
  try {
    loading.popup = true

    const { data } = await axios.get('app/iklan_popup')

    popup.value = data.data.length > 0 ? data.data[0] : null
  } catch (error) {
    console.error('Error dari popup getPopup', error)
    popup.value = null // reset jadi null kalau error
    throw error
  } finally {
    loading.popup = false
  }
}
